import { RiDashboardLine, RiBugLine, RiLayoutGridLine } from "react-icons/ri";
import { PERMISSION_KEYS } from "../../permissions/permissionKeys";

/** Work Items global section tabs (order = default “first available” priority). */
export const ISSUES_SECTION_NAV_ITEMS = [
  { id: "kanban", label: "Kanban board", icon: RiLayoutGridLine },
  { id: "all-issue", label: "All work items", icon: RiDashboardLine },
  { id: "my-issue", label: "My work items", icon: RiBugLine },
];

/** @param {URLSearchParams | { get: (k: string) => string | null }} searchParams */
export function issuesUrlActiveTab(searchParams) {
  const tab = searchParams.get("tab");
  if (tab === "my-issue") return "my-issue";
  if (tab === "all-issue") return "all-issue";
  if (tab != null && String(tab).trim() !== "") return "__invalid__";
  return "kanban";
}

/** @param {(key: string) => boolean} can */
export function canUseIssuesTab(can, tabId) {
  if (tabId === "kanban") {
    return can(PERMISSION_KEYS.KANBAN_VIEW);
  }
  if (tabId === "all-issue") return can(PERMISSION_KEYS.WORK_ITEMS_VIEW);
  if (tabId === "my-issue") return can(PERMISSION_KEYS.MY_WORK_ITEMS_VIEW);
  return false;
}

/** @param {(key: string) => boolean} can */
export function firstAllowedIssuesTabId(can) {
  for (const item of ISSUES_SECTION_NAV_ITEMS) {
    if (canUseIssuesTab(can, item.id)) return item.id;
  }
  return null;
}

export function buildIssuesPathForTab(tabId) {
  if (tabId === "kanban") return "/issues";
  if (tabId === "my-issue") return "/issues?tab=my-issue";
  return "/issues?tab=all-issue";
}

/**
 * Path for sidebar / deep links so “Work Items” opens the first tab the user may access
 * (e.g. only `MY_WORK_ITEMS_VIEW` → `/issues?tab=my-issue`).
 * @param {(key: string) => boolean} can
 */
export function getWorkItemsListPathForPermissions(can) {
  const first = firstAllowedIssuesTabId(can);
  if (!first) return "/issues";
  return buildIssuesPathForTab(first);
}
